// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.trustmanagement

import org.multipaz.cbor.DataItem
import org.multipaz.trustmanagement.TrustMetadata
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.Bstr
import org.multipaz.cbor.toDataItem
import org.multipaz.cbor.buildCborMap

fun TrustMetadata.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "Yn5hs7Xkf9ibDL2CHv2Ilt0kU_MUoVWwHI2Vc4G5vUM")
val TrustMetadata_cborSchemaId = ByteString(98, 126, 97, -77, -75, -28, 127, -40, -101, 12, -67, -126, 30, -3, -120, -106, -35, 36, 83, -13, 20, -95, 85, -80, 28, -115, -107, 115, -127, -71, -67, 67)

fun TrustMetadata.Companion.fromCbor(data: ByteArray): TrustMetadata {
    return TrustMetadata.fromDataItem(Cbor.decode(data))
}

val TrustMetadata.Companion.cborSchemaId: ByteString
    get() = TrustMetadata_cborSchemaId

fun TrustMetadata.toDataItem(): DataItem {
    val builder = CborMap.builder()
    val displayName = this.displayName
    if (displayName != null) {
        builder.put("displayName", Tstr(displayName))
    }
    val displayIcon = this.displayIcon
    if (displayIcon != null) {
        builder.put("displayIcon", Bstr(displayIcon.toByteArray()))
    }
    val displayIconUrl = this.displayIconUrl
    if (displayIconUrl != null) {
        builder.put("displayIconUrl", Tstr(displayIconUrl))
    }
    val privacyPolicyUrl = this.privacyPolicyUrl
    if (privacyPolicyUrl != null) {
        builder.put("privacyPolicyUrl", Tstr(privacyPolicyUrl))
    }
    val disclaimer = this.disclaimer
    if (disclaimer != null) {
        builder.put("disclaimer", Tstr(disclaimer))
    }
    builder.put("testOnly", this.testOnly.toDataItem())
    val map = this.extensions.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), Tstr(entry.value))
            }
        }
    }
    builder.put("extensions", map)
    return builder.end().build()
}

fun TrustMetadata.Companion.fromDataItem(dataItem: DataItem): TrustMetadata {
    val displayName0 = if (dataItem.hasKey("displayName")) {
        dataItem["displayName"].asTstr
    } else {
        null
    }
    val displayIcon0 = if (dataItem.hasKey("displayIcon")) {
        dataItem["displayIcon"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val displayIconUrl0 = if (dataItem.hasKey("displayIconUrl")) {
        dataItem["displayIconUrl"].asTstr
    } else {
        null
    }
    val privacyPolicyUrl0 = if (dataItem.hasKey("privacyPolicyUrl")) {
        dataItem["privacyPolicyUrl"].asTstr
    } else {
        null
    }
    val disclaimer0 = if (dataItem.hasKey("disclaimer")) {
        dataItem["disclaimer"].asTstr
    } else {
        null
    }
    val testOnly = dataItem["testOnly"].asBoolean
    val map0 = dataItem["extensions"].let {
        buildMap<String, String> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value.asTstr)
            }
        }
    }
    val extensions = map0
    return TrustMetadata(
        displayName = displayName0,
        displayIcon = displayIcon0,
        displayIconUrl = displayIconUrl0,
        privacyPolicyUrl = privacyPolicyUrl0,
        disclaimer = disclaimer0,
        testOnly = testOnly,
        extensions = extensions,
    )
}
